var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAvatarFallbackIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 156,
  height: 156,
  viewBox: "0 0 156 156",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    verticalAlign: "middle"
  }
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_7181_52071)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 156,
  height: 156,
  fill: "url(#paint0_linear_7181_52071)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107 62.5C107 87 94.0163 106 78 106C61.9837 106 49 87 49 62.5C49 46.2076 61.9837 34 78 34C94.0163 34 107 46.2076 107 62.5Z",
  fill: "#26054E",
  fillOpacity: 0.16
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 142.247C6 123.509 26.2087 108.186 51.7169 107.066C53.6284 106.982 55.4617 107.783 56.7826 109.167L73.8828 127.086C75.8526 129.15 79.1474 129.15 81.1172 127.086L98.2174 109.167C99.5384 107.783 101.372 106.982 103.283 107.066C128.791 108.186 149 123.509 149 142.247V154.753C149 174.22 127.19 190 100.286 190H54.7143C27.8101 190 6 174.22 6 154.753V142.247Z",
  fill: "#26054E",
  fillOpacity: 0.16
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.5364 84.015C73.5364 82.047 75.1684 80.4631 77.1364 80.4631C79.1044 80.4631 80.7364 82.047 80.7364 84.015C80.7364 86.031 79.1044 87.6151 77.1364 87.6151C75.1684 87.6151 73.5364 86.031 73.5364 84.015ZM72.8644 64.575C73.1524 64.575 73.3924 64.383 73.3924 64.095C73.3924 63.375 73.4884 62.655 73.4884 62.655C73.7764 59.775 75.7924 58.383 78.3364 58.383C80.7844 58.383 82.2724 60.015 82.2724 61.743C82.2724 64.719 79.7764 65.487 77.3764 67.599C74.8324 69.903 74.4004 71.919 74.4484 75.183L74.4964 76.5751C74.4964 76.8631 74.7364 77.1031 75.0244 77.1031H79.3444C79.5844 77.1031 79.7764 76.911 79.7764 76.671C79.7764 76.671 79.7284 75.135 79.7764 74.655C80.0164 72.495 81.4564 71.967 83.7604 70.479C86.7364 68.559 88.4164 66.111 88.4164 62.175C88.4164 56.463 84.1444 52.623 78.2884 52.623C76.8484 52.623 75.6004 52.767 74.4484 53.103C68.2564 54.927 67.5364 61.791 67.4404 63.999C67.4404 64.335 67.6804 64.575 67.9684 64.575H72.8644Z",
  fill: "white",
  fillOpacity: 0.8
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_7181_52071",
  x1: 78,
  y1: 0,
  x2: 78,
  y2: 156,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E9E5F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99359,
  stopColor: "#F3F3FF"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_7181_52071"
}, /*#__PURE__*/React.createElement("rect", {
  width: 156,
  height: 156,
  fill: "white"
})))));
export default SvgAvatarFallbackIcon;